import ExcelJS from 'exceljs';
import FileSaver from 'file-saver';
import { breakTitle } from "../../../Custom/Custom";

//Price Electricity Report

export const agriPriceElectricityReport = async (excelObjectData) => {

  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet(excelObjectData.sheetName);

  //First Row Design and Merge cells A1:O1
  worksheet.mergeCells(excelObjectData.firstRowMergeCells);
  const firstHeaderRow = worksheet.getRow(1);
  firstHeaderRow.getCell(1).value = excelObjectData.firstRowExportData
  firstHeaderRow.getCell(1).font = { name: 'SansSerif', size: 20 };
  firstHeaderRow.getCell(1).alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
  firstHeaderRow.height = 30;
  firstHeaderRow.getCell(1).border = {
    top: { style: 'thin' },
    left: { style: 'thin' },
    bottom: { style: 'thin' },
    right: { style: 'thin' },
  };

  const headerRow3 = worksheet.addRow(excelObjectData.headerEnglishColumns);
  headerRow3.height = 55;
  headerRow3.eachCell((cell, colNumber) => {
    cell.font = { bold: true, name: 'SansSerif', size: 10 };
    cell.alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
    cell.value = breakTitle(cell.value);
    cell.border = {
      top: { style: 'thin' },
      left: { style: 'thin' },
      bottom: { style: 'thin' },
      right: { style: 'thin' },

    };
    const column = worksheet.getColumn(colNumber);
    column.width = 16;

  });

  excelObjectData.excelRowData.forEach((row) => {  //Excel Data Loop
    const dataRow = worksheet.addRow(row);
    dataRow.height = 30;
    let isTotalRow = false;
    row.forEach((value, index) => {
      const cell = dataRow.getCell(index + 1);
      cell.font = { name: 'SansSerif', size: 10 };
      cell.alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
      cell.border = {
        top: { style: 'thin' },
        left: { style: 'thin' },
        bottom: { style: 'thin' },
        right: { style: 'thin' },
      };
      if (value === 'TOTAL') {
        isTotalRow = true;
      }
      // Customize styling for the cells if needed
    });

    if (isTotalRow) {
      dataRow.eachCell({ includeEmpty: true }, (cell) => {
        cell.font = { name: 'SansSerif', size: 12, bold: true };
      });
    }
  });

  const totalsRow = worksheet.addRow([]); // Add a new row for totals



  worksheet.columns.forEach((column) => {
    column.width = 15;
  });

  const buffer = await workbook.xlsx.writeBuffer();
  const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8' });
  const fileName = `${excelObjectData.fileName}.${excelObjectData.fileType}`;
  FileSaver.saveAs(blob, fileName);
};

// Variation Report

export const variationReport67 = async (excelObjectData) => {

  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet(excelObjectData.sheetName);
  const cWeekData = excelObjectData.subData

  const cWeek = excelObjectData.subData[0].CDate_c_week;
  console.warn("cWeekData", cWeekData)
  const mWeek = excelObjectData.subData[0].CDate_m_week;

  const pWeek = excelObjectData.subData[0].CDate_p_week;
  const qWeek = excelObjectData.subData[0].CDate_q_week;

  //First Row Design and Merge cells A1:K1
  worksheet.mergeCells(excelObjectData.firstRowMergeCells);
  const firstHeaderRow = worksheet.getRow(1);
  firstHeaderRow.getCell(1).value = excelObjectData.firstRowExportDate
  firstHeaderRow.getCell(1).font = { name: 'SansSerif', size: 10 };
  firstHeaderRow.getCell(1).alignment = { horizontal: 'right', vertical: 'middle', wrapText: true };
  firstHeaderRow.height = 20;
  firstHeaderRow.getCell(1).border = {
    top: { style: 'thin' },
    left: { style: 'thin' },
    bottom: { style: 'thin' },
    right: { style: 'thin' },
  };


  //Second Row Design and Merge cells A2:K2

  worksheet.mergeCells(excelObjectData.secondRowMergeCells);
  const secondHeaderRow = worksheet.getRow(2);
  secondHeaderRow.getCell(1).value = excelObjectData.secondRowText
  secondHeaderRow.getCell(1).font = { name: 'SansSerif', size: 20 };
  secondHeaderRow.getCell(1).alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
  secondHeaderRow.height = 60;
  secondHeaderRow.getCell(1).border = {
    top: { style: 'thin' },
    left: { style: 'thin' },
    bottom: { style: 'thin' },
    right: { style: 'thin' },
  };



  //Third Row Design and Merge cells A1:O1

  worksheet.mergeCells(excelObjectData.thirdRowMergeCells);
  const thirdHeaderRow = worksheet.getRow(3);
  thirdHeaderRow.getCell(1).value = excelObjectData.thirdRowText
  thirdHeaderRow.getCell(1).font = { name: 'SansSerif', size: 17 };
  thirdHeaderRow.getCell(1).alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
  thirdHeaderRow.height = 30;
  thirdHeaderRow.getCell(1).border = {
    top: { style: 'thin' },
    left: { style: 'thin' },
    bottom: { style: 'thin' },
    right: { style: 'thin' },
  };

  const headerRow1 = worksheet.addRow([
    'वस्तु का नाम', 'इकाई मात्रा', 'औसत  भाव (रू0 में)', '', '', '', ' अन्तर प्रतिशत में ', '', '', '', '']);

  headerRow1.height = 30;
  headerRow1.eachCell((cell, colNumber) => {
    cell.font = { bold: true, name: 'SansSerif', size: 10 };
    cell.alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
    cell.border = {
      top: { style: 'thin' },
      left: { style: 'thin' },
      bottom: { style: 'thin' },
      right: { style: 'thin' },
    };
  });

  worksheet.mergeCells('C4:F4');
  worksheet.mergeCells('G4:K4');

  const formatDate = (date) => {
    const options = { day: '2-digit', month: 'short', year: 'numeric' };
    return date.toLocaleDateString('en-GB', options); // en-GB for 'dd MMM yyyy' format
  };

  // Function to create and add Header Row 2
  const addHeaderRow2 = () => {
    // Extract priceDate from excelObjectData
    const priceDateStr = excelObjectData.priceDate;

    // Parse priceDate into a Date object
    const [day, month, year] = priceDateStr.split(' ');
    const monthIndex = new Date(Date.parse(month + " 1, 2020")).getMonth(); // Get month index
    const priceDate = new Date(`${year}-${monthIndex + 1}-${day}`); // Convert to Date object

    // Calculate the date 1 week and 4 weeks before the priceDate
    const oneWeekBeforeDate = new Date(priceDate);
    oneWeekBeforeDate.setDate(priceDate.getDate() - 7); // 1 Week

    const fourWeeksBeforeDate = new Date(priceDate);
    fourWeeksBeforeDate.setDate(priceDate.getDate() - 28); // 1 Month

    const thirteenWeeksBeforeDate = new Date(priceDate);
    thirteenWeeksBeforeDate.setDate(priceDate.getDate() - 91); // 3 Month

    const fiftytwoWeeksBeforeDate = new Date(priceDate);
    fiftytwoWeeksBeforeDate.setDate(priceDate.getDate() - 364); // Yearly

    // Format the dates
    const formattedOneWeekBeforeDate = formatDate(oneWeekBeforeDate);
    const formattedFourWeeksBeforeDate = formatDate(fourWeeksBeforeDate);
    const formattedthirteenWeeksBeforeDate = formatDate(thirteenWeeksBeforeDate);
    const formattedFiftytwoWeeksBeforeDate = formatDate(fiftytwoWeeksBeforeDate);
    // Add the row to the worksheet with the updated dates

    const row = worksheet.addRow([
      '', '',
      formattedFiftytwoWeeksBeforeDate,
      qWeek ? `${formattedthirteenWeeksBeforeDate} submitted on ${qWeek}` : formattedthirteenWeeksBeforeDate,
      mWeek ? `${formattedFourWeeksBeforeDate} submitted on ${mWeek}` : formattedFourWeeksBeforeDate,
      cWeek ? `${formattedOneWeekBeforeDate} submitted on ${cWeek}` : formattedOneWeekBeforeDate,
      cWeek ? `${excelObjectData.priceDate} submitted on ${cWeek}` : `${excelObjectData.priceDate}`,
      'वार्षिक',
      'त्रैमासिक',
      'मासिक',
      'साप्ताहिक'
    ]);

    return row;
  };

  // Call the function to add Header Row 2
  const addedRow = addHeaderRow2();

  // Set the height and styling for Header Row 2
  addedRow.height = 45;
  addedRow.eachCell((cell, colNumber) => {
    cell.font = { bold: true, name: 'SansSerif', size: 10 };
    cell.alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
    cell.border = {
      top: { style: 'thin' },
      left: { style: 'thin' },
      bottom: { style: 'thin' },
      right: { style: 'thin' },
    };
  });

  worksheet.mergeCells('A4:A5');
  worksheet.mergeCells('B4:B5');


  //six Row Design and Merge cells A1:O1
  const headerRow6 = worksheet.addRow([1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11]);
  headerRow6.height = 35;
  headerRow6.eachCell((cell, colNumber) => {
    cell.font = { bold: true, name: 'SansSerif', size: 10 };
    cell.alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
    cell.border = {
      top: { style: 'thin' },
      left: { style: 'thin' },
      bottom: { style: 'thin' },
      right: { style: 'thin' },
    };
  });


  excelObjectData.excelRowData.forEach((row) => {  //Excel Data Loop
    const dataRow = worksheet.addRow(row);
    dataRow.height = 27;
    row.forEach((value, index) => {
      const cell = dataRow.getCell(index + 1);
      cell.font = { name: 'SansSerif', size: 10 };
      cell.alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
      cell.border = {
        top: { style: 'thin' },
        left: { style: 'thin' },
        bottom: { style: 'thin' },
        right: { style: 'thin' },
      };
      // Customize styling for the cells if needed
    });

  });
  worksheet.columns.forEach(column => {
    column.width = 15;
  });

  const buffer = await workbook.xlsx.writeBuffer();
  const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8' });
  const fileName = `${excelObjectData.fileName}.${excelObjectData.fileType}`;
  FileSaver.saveAs(blob, fileName);
};



export const generateWholesaleHapurReport = async (excelObjectData) => {
  console.warn("SSSSSSSSSSSSSSSSSSSSS", excelObjectData)
  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet(excelObjectData.sheetName);


  //excel Hindi Column

  const headerRow1 = worksheet.addRow(['माह  के प्रथम शुक्रवार के भाव', '', '', `${excelObjectData.firstRowExportDate}`, '']);
  headerRow1.height = 35;
  headerRow1.eachCell((cell, colNumber) => {
    cell.font = { bold: true, name: 'SansSerif', size: 10 };
    cell.alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
    cell.border = {
      top: { style: 'thin' },
      left: { style: 'thin' },
      bottom: { style: 'thin' },
      right: { style: 'thin' },

    };
    const column = worksheet.getColumn(colNumber);
    column.width = 25;


  });

  worksheet.mergeCells('A1:C1');
  worksheet.mergeCells('D1:E1');




  const headerRow2 = worksheet.addRow(['जनपद - गाज़ियाबाद', '', `भाव दिनांक :-${excelObjectData.fromDate}`, '', '']);
  headerRow2.height = 20;
  headerRow2.eachCell((cell, colNumber) => {
    cell.font = { bold: true, name: 'SansSerif', size: 10 };
    cell.alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
    cell.border = {
      top: { style: 'thin' },
      left: { style: 'thin' },
      bottom: { style: 'thin' },
      right: { style: 'thin' },

    };
    const column = worksheet.getColumn(colNumber);
    column.width = 25;
  });

  worksheet.mergeCells('A2:B2');
  worksheet.mergeCells('C2:E2');

  // const headerRow3 = worksheet.addRow([
  //   'क्रम संख्या',
  //   'वस्तु का नाम',
  //   'इकाई मात्रा',
  //   'औसत  भाव (रू0 में)'
  // ]);
  // headerRow3.height = 35;
  // headerRow3.eachCell((cell, colNumber) => {
  //   cell.font = { bold: true, name: 'SansSerif', size: 10 };
  //   cell.alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
  //   cell.border = {
  //     top: { style: 'thin' },
  //     left: { style: 'thin' },
  //     bottom: { style: 'thin' },
  //     right: { style: 'thin' },
  //   };
  // });

  const headerRow3 = worksheet.addRow(excelObjectData.headerHindiColumns);
  headerRow3.height = 55;
  headerRow3.eachCell((cell, colNumber) => {
    cell.font = { bold: true, name: 'SansSerif', size: 10 };
    cell.alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
    cell.value = breakTitle(cell.value);
    cell.border = {
      top: { style: 'thin' },
      left: { style: 'thin' },
      bottom: { style: 'thin' },
      right: { style: 'thin' },

    };
    const column = worksheet.getColumn(colNumber);
    column.width = 16;

  });


  excelObjectData.excelRowData.forEach((row) => {  //Excel Data Loop
    console.warn("@@@@@@@", excelObjectData)
    const dataRow = worksheet.addRow(row);
    dataRow.height = null;
    let isTotalRow = false;
    row.forEach((value, index) => {
      const cell = dataRow.getCell(index + 1);
      cell.font = { name: 'SansSerif', size: 10 };
      cell.alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
      cell.border = {
        top: { style: 'thin' },
        left: { style: 'thin' },
        bottom: { style: 'thin' },
        right: { style: 'thin' },
      };
      if (value === 'TOTAL') {
        isTotalRow = true;
      }
      // Customize styling for the cells if needed
    });

    if (isTotalRow) {
      dataRow.eachCell({ includeEmpty: true }, (cell) => {
        cell.font = { name: 'SansSerif', size: 12, bold: true };
      });
    }

  });
  const buffer = await workbook.xlsx.writeBuffer();
  const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8' });
  const fileName = `${excelObjectData.fileName}.${excelObjectData.fileType}`;
  FileSaver.saveAs(blob, fileName);
};

//********** RCPI ************/

export const generateRCPI = async (excelObjectData) => {
  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet(excelObjectData.sheetName);

  // Define styles
  const styleGroup = { fill: { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFFCD658' } } }; // Yellow
  const styleSubGroup = { fill: { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFCBB88A' } } }; // Brown
  const colorStyle = { fill: { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FF616362' } } }; // Gray

  // First Row Design and Merge cells A1:K1
  worksheet.mergeCells(excelObjectData.firstRowMergeCells);
  const firstHeaderRow = worksheet.getRow(1);
  firstHeaderRow.getCell(1).value = excelObjectData.firstRowExportDate;
  firstHeaderRow.getCell(1).font = { name: 'SansSerif', size: 10 };
  firstHeaderRow.getCell(1).alignment = { horizontal: 'right', vertical: 'middle', wrapText: true };
  firstHeaderRow.height = 20;
  firstHeaderRow.getCell(1).border = {
    top: { style: 'thin' },
    left: { style: 'thin' },
    bottom: { style: 'thin' },
    right: { style: 'thin' },
  };

  // Second Row Design and Merge cells A2:K2
  worksheet.mergeCells(excelObjectData.secondRowMergeCells);
  const secondHeaderRow = worksheet.getRow(2);
  secondHeaderRow.getCell(1).value = excelObjectData.secondRowText;
  secondHeaderRow.getCell(1).font = { bold: true, name: 'SansSerif', size: 12 };
  secondHeaderRow.getCell(1).alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
  secondHeaderRow.height = 30;
  secondHeaderRow.getCell(1).border = {
    top: { style: 'thin' },
    left: { style: 'thin' },
    bottom: { style: 'thin' },
    right: { style: 'thin' },
  };

  const headerRow1 = worksheet.addRow(['क्रम स0', 'मद', 'भार', 'आधार वर्ष', 'राज्य स्तरीय', '', '']);
  headerRow1.height = 20;
  headerRow1.eachCell((cell) => {
    cell.font = { bold: true, name: 'SansSerif', size: 10 };
    cell.alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
    cell.border = {
      top: { style: 'thin' },
      left: { style: 'thin' },
      bottom: { style: 'thin' },
      right: { style: 'thin' },
    };
  });

  const headerRow2 = worksheet.addRow(['', '', '', '2011-12', `${excelObjectData.baseYear}-${parseInt(excelObjectData.baseYear) + 1}`, 'सूचकांक', '']);
  headerRow2.height = 20;
  headerRow2.eachCell((cell) => {
    cell.font = { bold: true, name: 'SansSerif', size: 10 };
    cell.alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
    cell.border = {
      top: { style: 'thin' },
      left: { style: 'thin' },
      bottom: { style: 'thin' },
      right: { style: 'thin' },
    };
  });

  const headerRow3 = worksheet.addRow(['1', '2', '3', '4', '5', '6', '7']);
  headerRow3.height = 20;
  headerRow3.eachCell((cell) => {
    cell.font = { bold: true, name: 'SansSerif', size: 10 };
    cell.alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
    cell.border = {
      top: { style: 'thin' },
      left: { style: 'thin' },
      bottom: { style: 'thin' },
      right: { style: 'thin' },
    };
  });


  const headerRow4 = worksheet.addRow(['', 'समस्त वर्ग', '0.00', '', '', '', 'All Groups']);
  headerRow4.height = 30;
  headerRow4.eachCell({ includeEmpty: true }, (cell, colNumber) => {
    cell.font = { bold: true, name: 'SansSerif', size: 12 };
    cell.alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
    cell.border = {
      top: { style: 'thin' },
      left: { style: 'thin' },
      bottom: { style: 'thin' },
      right: { style: 'thin' },
    };

    // Apply color to specific columns
    if ([2, 3, 6, 7].includes(colNumber)) {
      cell.fill = colorStyle.fill;
    }
  });

  // Set column widths
  worksheet.getColumn(2).width = 30; // Set width of column B (index 2) to 30
  worksheet.getColumn(7).width = 30; // Set width of column G (index 7) to 30

  // Set width for all other columns to 15
  worksheet.columns.forEach(col => {
    if (col.number !== 2 && col.number !== 7) {
      col.width = 15;
    }
  });

  // Excel Data Loop with Conditional Formatting
  excelObjectData.excelRowData.forEach((row) => {
    const type = row[0]; // Assumes the type is the first element in the row
    const rowData = row.slice(1); // Exclude the first element
    const dataRow = worksheet.addRow(rowData);

    if (type === 'group' || type === 'subgroup') {
      dataRow.height = 30;
    } else {
      dataRow.height = null; // Default height
    }

    rowData.forEach((value, index) => {
      const cell = dataRow.getCell(index + 1);
      cell.font = { name: 'SansSerif', size: 10 };
      cell.alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };


      if (type === 'group') {
        if ([2, 3, 6, 7].includes(index + 1)) {
          cell.style = { ...styleGroup, font: { ...styleGroup.font, bold: true } };
        }
      } else if (type === 'subgroup') {
        if ([2, 3, 6, 7].includes(index + 1)) {
          cell.style = { ...styleSubGroup, font: { ...styleSubGroup.font, bold: true } };
        }
      }
      cell.border = {
        top: { style: 'thin' },
        left: { style: 'thin' },
        bottom: { style: 'thin' },
        right: { style: 'thin' },
      };
    });
  });

  const buffer = await workbook.xlsx.writeBuffer();
  const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8' });
  const fileName = `${excelObjectData.fileName}.${excelObjectData.fileType}`;
  FileSaver.saveAs(blob, fileName);
};

// ********** THOK 1 **********

export const generateThok1 = async (excelObjectData) => {

  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet(excelObjectData.sheetName);

  //First Row Design and Merge cells A1:O1
  worksheet.mergeCells(excelObjectData.firstRowMergeCells);
  const firstHeaderRow = worksheet.getRow(1);
  firstHeaderRow.getCell(1).value = excelObjectData.firstRowExportData
  firstHeaderRow.getCell(1).font = { name: 'SansSerif', size: 10 };
  firstHeaderRow.getCell(1).alignment = { horizontal: 'right', vertical: 'middle', wrapText: true };
  firstHeaderRow.height = 15;


  const headerRow1 = worksheet.addRow([
    'कृषि से प्राप्त भाव  सूचकांक  - Thok1 (आधार वर्ष 2011-12=100)', '', '', '', '', '', '', '', '', '', '', '2016-17', '', '', '', ''
  ]);
  headerRow1.height = 30;
  headerRow1.eachCell((cell, colNumber) => {
    cell.font = { bold: true, name: 'SansSerif', size: 18 };
    cell.alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
    cell.border = {
      top: { style: 'thin' },
      left: { style: 'thin' },
      bottom: { style: 'thin' },
      right: { style: 'thin' },
    };
  });

  worksheet.mergeCells('A2:K2');
  worksheet.mergeCells('L2:P2');



  headerRow1.eachCell((cell, colNumber) => {
    worksheet.getColumn(colNumber).width = 15;
  });


  const headerRow2 = worksheet.addRow(excelObjectData.headerEnglishColumns);
  headerRow2.height = 60;
  headerRow2.eachCell((cell, colNumber) => {
    cell.font = { bold: true, name: 'SansSerif', size: 10 };
    cell.alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
    cell.value = breakTitle(cell.value);
    cell.border = {
      top: { style: 'thin' },
      left: { style: 'thin' },
      bottom: { style: 'thin' },
      right: { style: 'thin' },

    };
    const column = worksheet.getColumn(colNumber);
    column.width = 16;

  });


  const headerRow3 = worksheet.addRow([
    '', '', `${excelObjectData.surveyYear}`, `${excelObjectData.surveyYear}`, `${excelObjectData.surveyYear}`, `${excelObjectData.surveyYear}`, `${excelObjectData.surveyYear}`, `${excelObjectData.surveyYear}`, `${parseInt(excelObjectData.surveyYear) + 1}`, `${parseInt(excelObjectData.surveyYear) + 1}`, `${parseInt(excelObjectData.surveyYear) + 1}`, `${parseInt(excelObjectData.surveyYear) + 1}`, `${parseInt(excelObjectData.surveyYear) + 1}`, `${parseInt(excelObjectData.surveyYear) + 1}`, `${parseInt(excelObjectData.surveyYear) + 1}`, `${parseInt(excelObjectData.surveyYear) + 1}`
  ]);
  headerRow3.height = 30;
  headerRow3.eachCell((cell, colNumber) => {
    cell.font = { bold: true, name: 'SansSerif', size: 10 };
    cell.alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
    cell.border = {
      top: { style: 'thin' },
      left: { style: 'thin' },
      bottom: { style: 'thin' },
      right: { style: 'thin' },
    };
  });



  const headerRow4 = worksheet.addRow([
    '1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12', '13', '14', '15', '16'
  ]);
  headerRow4.height = 20;
  headerRow4.eachCell((cell, colNumber) => {
    cell.font = { bold: true, name: 'SansSerif', size: 10 };
    cell.alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
    cell.border = {
      top: { style: 'thin' },
      left: { style: 'thin' },
      bottom: { style: 'thin' },
      right: { style: 'thin' },
    };
  });


  worksheet.getColumn(1).width = 25; // Set width of column B (index 2) to 30


  // Set width for all other columns to 15
  worksheet.columns.forEach(col => {
    if (col.number !== 1) {
      col.width = 10;
    }
  });

  // Calculate sums for columns 2 and 16
  let sumColumn2 = 0;
  let sumColumn16 = 0;

  excelObjectData.excelRowData.forEach((row) => {

    if (typeof row[1] === 'number') {
      sumColumn2 += row[1];
    }
    if (typeof row[15] === 'number') {
      sumColumn16 += row[15];
    }
    const dataRow = worksheet.addRow(row);
    dataRow.height = null;
    let isTotalRow = false;
    row.forEach((value, index) => {
      const cell = dataRow.getCell(index + 1);
      cell.font = { name: 'SansSerif', size: 10 };
      cell.alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
      cell.border = {
        top: { style: 'thin' },
        left: { style: 'thin' },
        bottom: { style: 'thin' },
        right: { style: 'thin' },
      };
      if (value === 'TOTAL') {
        isTotalRow = true;
      }
    });
  });
  const totalRow = worksheet.addRow(Array.from({ length: worksheet.columnCount }, (_, i) => {
    if (i === 0) return 'Total'; // First column
    if (i === 1) return sumColumn2; // Column 2
    if (i === 15) return sumColumn16; // Column 16
    return '';
  }));
  totalRow.height = 20;
  totalRow.eachCell((cell, colNumber) => {
    cell.font = { bold: true, name: 'SansSerif', size: 10 };
    cell.alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
    cell.border = {
      top: { style: 'thin' },
      left: { style: 'thin' },
      bottom: { style: 'thin' },
      right: { style: 'thin' },
    };
  });

  const buffer = await workbook.xlsx.writeBuffer();
  const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8' });
  const fileName = `${excelObjectData.fileName}.${excelObjectData.fileType}`;
  FileSaver.saveAs(blob, fileName);
};


//********* Review Report**********

export const generateReviewReport = async (excelObjectData) => {
  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet(excelObjectData.sheetName);

  // First row
  worksheet.mergeCells(excelObjectData.firstRowMergeCells);
  const firstHeaderRow = worksheet.getRow(1);
  firstHeaderRow.getCell(1).value = excelObjectData.firstRowExportDate;
  firstHeaderRow.getCell(1).font = { name: 'SansSerif', size: 10 };
  firstHeaderRow.getCell(1).alignment = { horizontal: 'right', vertical: 'middle', wrapText: true };
  firstHeaderRow.height = 15;
  firstHeaderRow.getCell(1).border = {
    top: { style: 'thin' },
    left: { style: 'thin' },
    bottom: { style: 'thin' },
    right: { style: 'thin' },
  };

  // Second Row
  worksheet.mergeCells(excelObjectData.secondRowMergeCells);
  const secondHeaderRow = worksheet.getRow(2);
  secondHeaderRow.getCell(1).value = excelObjectData.secondRowText;
  secondHeaderRow.getCell(1).font = { bold: true, name: 'SansSerif', size: 15 };
  secondHeaderRow.getCell(1).alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
  secondHeaderRow.height = 30;
  secondHeaderRow.getCell(1).border = {
    top: { style: 'thin' },
    left: { style: 'thin' },
    bottom: { style: 'thin' },
    right: { style: 'thin' },
  };

  // Third Row
  worksheet.mergeCells(excelObjectData.thirdRowMergeCells);
  const thirdHeaderRow = worksheet.getRow(3);
  thirdHeaderRow.getCell(1).value = excelObjectData.thirdRowText;
  thirdHeaderRow.getCell(1).font = { bold: true, name: 'SansSerif', size: 15 };
  thirdHeaderRow.getCell(1).alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
  thirdHeaderRow.height = 50;
  thirdHeaderRow.getCell(1).border = {
    top: { style: 'thin' },
    left: { style: 'thin' },
    bottom: { style: 'thin' },
    right: { style: 'thin' },
  };

  // Header Row
  const headerRow3 = worksheet.addRow(excelObjectData.headerHindiColumns);
  headerRow3.height = 55;
  headerRow3.eachCell((cell) => {
    cell.font = { bold: true, name: 'SansSerif', size: 10 };
    cell.alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
    cell.value = breakTitle(cell.value); // Assuming breakTitle is defined elsewhere
    cell.border = {
      top: { style: 'thin' },
      left: { style: 'thin' },
      bottom: { style: 'thin' },
      right: { style: 'thin' },
    };
  });

  worksheet.getColumn(1).width = 30;
  worksheet.getColumn(2).width = 20;
  worksheet.getColumn(3).width = 80;

  // Track the row index for insertion
  let targetIndex = -1;

  // Add data rows and determine the row to insert new rows
  excelObjectData.excelRowData.forEach((row, index) => {
    const dataRow = worksheet.addRow(row);
    dataRow.height = 60;
    let isTotalRow = false;

    row.forEach((value, cellIndex) => {
      const cell = dataRow.getCell(cellIndex + 1);
      cell.font = { name: 'SansSerif', size: 10 };
      cell.alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
      cell.border = {
        top: { style: 'thin' },
        left: { style: 'thin' },
        bottom: { style: 'thin' },
        right: { style: 'thin' },
      };
      if (value === 'TOTAL') {
        isTotalRow = true;
      }
    });

    if (isTotalRow) {
      dataRow.eachCell({ includeEmpty: true }, (cell) => {
        cell.font = { name: 'SansSerif', size: 12, bold: true };
      });
    }

    // Check if the current row has the target value
    if (row[0].trim() === "Equal TO 0.0" || row[0].trim() === "Equal To 0.0") {
      targetIndex = worksheet.rowCount;
    }
  });


  
  // Insert additional rows if the target index is found
  if (targetIndex !== -1) {
    worksheet.insertRow(targetIndex, ['', '', '']);
    worksheet.getRow(targetIndex).height = 20;

    const row1 = worksheet.insertRow(targetIndex + 1, ['बराबरी  दर प्रतिशत', 'वस्तुओ की संख्या', 'वस्तु का नाम # असमानता %']);
    row1.height = 60;
    row1.eachCell({ includeEmpty: true }, (cell) => {
      cell.font = { bold: true, name: 'SansSerif', size: 10 };
      cell.alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
      cell.border = {
        top: { style: 'thin' },
        left: { style: 'thin' },
        bottom: { style: 'thin' },
        right: { style: 'thin' },
      };
    });

    worksheet.insertRow(targetIndex + 3, ['', '', '']);
    worksheet.getRow(targetIndex + 3).height = 20;


    const row2 = worksheet.insertRow(targetIndex + 4, ['कमी दर प्रतिशत  सीमा', 'वस्तुओ की संख्या', 'वस्तु का नाम # असमानता %']);
    row2.height = 60;
    row2.eachCell({ includeEmpty: true }, (cell) => {
      cell.font = { bold: true, name: 'SansSerif', size: 10 };
      cell.alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
      cell.border = {
        top: { style: 'thin' },
        left: { style: 'thin' },
        bottom: { style: 'thin' },
        right: { style: 'thin' },
      }; 
    });
  }


  // Add totals row
  const totalsRow = worksheet.addRow([]); // Add a new row for totals

  // Save the workbook
  const buffer = await workbook.xlsx.writeBuffer();
  const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8' });
  const fileName = `${excelObjectData.fileName}.${excelObjectData.fileType}`;
  FileSaver.saveAs(blob, fileName);
};

